import validateForm from 'cerebral-module-forms/factories/validateForm'

export default function validateAllForms() {
  function action(context) {
    let state = context.state
    let forms = state.get('client.registrating.current')
    Object.keys(forms).forEach(form => {
      validateForm(`client.registrating.current.${form}`)(context)
    })
  }
  return action
}



// WEBPACK FOOTER //
// ./src/modules/user/factories/validateAllForms.js